import tablelist from "@components/templates/tablelist";
import compUpdate from "./update";
import compIntercept from "./intercept";
import mixin from "./mixin";
import comExcel from '@components/templates/excelalert';
import {
    HttpGetManageInterceptList
} from "@/service/intercept/index";
import { mapState, mapGetters } from "vuex";

export default {
    mixins: [tablelist, mixin],
    components: {
        compUpdate,
        compIntercept,
        comExcel
    },
    data () {
        return {
            isMixin: true,
            Tabs: { show: true },
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            formData: {},
            ccc:1
        }
    },
    methods: {
        ajaxRequest:HttpGetManageInterceptList,
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('global.common.operation_seee',{defaultValue:'查看'}),
                        show: true,
                        width:1200,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryOrder":
                    {
                        let url = this.$router.resolve({
                            name: "b2cOrderupdate",
                            query: {
                                id: params
                            },
                            params: {
                                type: "query"
                            }
                        }).href;
                        window.open(url, "__blank");
                    }
                    break;
                case "add":
                    {
                        this.operate = {
                            show: true,
                            title: this.$t('erp.product.new_add',{defaultValue:'添加'}),
                            width: 900,
                            component: "compIntercept",
                            showFooter: false,
                        };
                    }
                    break;
                case 'exportExcel':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/interceptOrder/export', {...this.formData,isManage:1}, { executor: 'request', download: true })
                    // .then(res => {
                    //     this.operate = {
                    //         title: this.$t('global.common.export', { defaultValue: '导出' }),
                    //         show: true,
                    //         width: 560,
                    //         component: "comExcel",
                    //         showFooter: false
                    //     }
                    // });
                    break;
            }
        }
    },
    computed: {
        ...mapGetters("dictionary", ["getOrgList",]),
        TabsData () {
            return [
                {
                    name: this.$t('global.common.all',{defaultValue:'全部'}),
                    key: "EQ_interceptStatus",
                    val: null
                },
                {
                    name: this.$t('erp.b2c.intercepting_in_progress',{defaultValue:'拦截中'}),
                    key: "EQ_interceptStatus",
                    val: 0
                },
                {
                    name:  this.$t('erp.b2c.partial_interception',{defaultValue:'部分拦截'}),
                    key: "EQ_interceptStatus",
                    val: 3
                },
                {
                    name: this.$t('erp.b2c.intercepted_successfully',{defaultValue:'拦截成功'}),
                    key: "EQ_interceptStatus",
                    val: 1
                },
                {
                    name:this.$t('erp.b2c.intercept_failed',{defaultValue:'拦截失败'}),
                    key: "EQ_interceptStatus",
                    val: 2
                }
            ]
        },
        SearchsData () {
            return [
                {
                    label: this.$t('erp.b2c.intercept_tracking_number',{defaultValue:'拦截单号'}),
                    tag: "Input",
                    key: "CN_interceptNo",
                    show: true
                },
                {
                    label: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
                    tag: "Input",
                    key: "CN_orderNo",
                    show: true
                },
                {
                    label: this.$t('erp.b2c.intercept_status',{defaultValue:'拦截状态'}),
                    tag: "Select",
                    key: "IN_interceptStatus",
                    options: this.getInterceptStatus,
                    props: {
                        multiple: true
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.organization',{defaultValue:'组织'}),
                    tag: "Select",
                    key: "IN_orgId",
                    options: this.getOrgList,
                    props: {
                        multiple: true,
                        filterable:true,
                    },
                },
                {
                    label: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    tag: "vDatepicker",
                    key: "BT_createdAt",
                    props: {
                        type: "daterange",
                        confirm: false
                    },
                    style: {
                        width: "180px"
                    },
                }
            ]
        },
        ToolsData(){
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "exportExcel",
                    theme: "success",
                },
            ]
        },
        columns () {
            return [
                {
                    title: this.$t('erp.b2c.intercept_tracking_number',{defaultValue:'拦截单号'}),
                    key: "interceptNo",
                    render: (h, { row }) => {
                        return <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.interceptNo}</a>
                    }
                },
                {
                    title: this.$t('erp.b2c.table_title2',{defaultValue:'订单号/平台订单号'}),
                    render: (h, { row }) => {
                        return <a onClick={this.handleOperates.bind(this, row.orderId, 'queryOrder')}>{row.orderId}/{row.orderNo}</a>
                    }
                },
                {
                    title:this.$t('global.common.organization',{defaultValue:'组织'}),
                    key:'orgName',
                },
                {
                    title: this.$t('erp.b2c.intercept_status',{defaultValue:'拦截状态'}),
                    render: (h, { row }) => {
                        let label = this.getInterceptStatus.filter(item => {
                            return item.value == row.interceptStatus;
                        })[0];
                        return <span class={`color-${label.theme}`} style="border-radius: 5px; padding: 3px 10px; border: 1px solid;">{label.label}</span>;
                    }
                },
                {
                    title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    key: "createdAt"
                },
                {
                    title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    key: "updatedAt"
                }
            ]
        }
    }
}